export const ML_PACKAGE_UPLOAD_TIME_EVENT = 'MLPackage.UploadTime';
export const DATALABELLING_GENERAL_TAB_TEMPLATE_UPDATE = 'DataLabelling.GeneralTabTemplateUpdate';
export const DATALABELLING_ADVANCED_TAB_TEMPLATE_UPDATE = 'DataLabelling.AdvancedTabTemplateUpdate';
export const EXPORT_COMPLETED = 'DataLabelling.ExportCompleted';
export const PERMISSIONS_FAILED_MSG = 'Error fetching permissions';

export const IDP_COMM_ISSUE_MSG = 'Error Communicating with IDP';
